import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { media } from 'context';
import { Layout, Text } from 'ds';
import { SERVICES_REQUEST_PATH } from 'routes/paths';
import thinkingGif from 'shared/assets/Thinking.gif';

import { ReactComponent as AiAssistantIcon } from 'ds/ai-assistant.svg';

import './ServicesRequest.scss';

interface Props {}

const ServicesReqeustWelcome: React.FC<Props> = () => {
  const { isMobile } = useContext(media);
  const history = useHistory();
  useEffect(() => {
    const id = setTimeout(() => {
      history.push(`${SERVICES_REQUEST_PATH}/services`);
    }, 5_500);

    return () => clearTimeout(id);
  }, [history]);

  if (isMobile) {
    return (
      <Layout
        background="linear-gradient(86deg, rgba(0, 120, 255, 0.05) 0%, rgba(142, 95, 244, 0.05) 100%)"
        height="100vh"
        width="100vw"
        align="center"
        justify="center"
      >
        <Layout position="relative">
          <Layout align="center" gap={16}>
            <AiAssistantIcon
              className="services-request-welcome-ai-assistant-icon-is-mobile"
              style={{ flexShrink: 0 }}
              width={40}
              height={40}
            />
            <img
              src={thinkingGif}
              alt="AI is thinking"
              width={40}
              height={40}
              className="services-request-welcome-thinking-is-mobile"
              style={{ objectFit: 'contain', objectPosition: 'center', width: 40, height: 40 }}
            />
          </Layout>
          <Layout className="services-request-welcome-hi-im-codi-is-mobile">
            <Text size="headline-md" color="purple-gradient" wrap={false}>
              Hi, I'm Codi — your new
              <br />
              office assistant.
            </Text>
          </Layout>
          <Layout className="services-request-welcome-lets-kick-things-off-is-mobile">
            <Text size="headline-md" color="purple-gradient" wrap={false}>
              Let's kick things off!
            </Text>
          </Layout>
        </Layout>
      </Layout>
    );
  }

  return (
    <Layout
      background="linear-gradient(86deg, rgba(0, 120, 255, 0.05) 0%, rgba(142, 95, 244, 0.05) 100%)"
      height="100vh"
      width="100vw"
      align="center"
      justify="center"
    >
      <Layout position="relative">
        <Layout align="center" gap={16}>
          <AiAssistantIcon
            className="services-request-welcome-ai-assistant-icon"
            style={{ flexShrink: 0 }}
            width={72}
            height={72}
          />
          <img
            src={thinkingGif}
            alt="AI is thinking"
            width={72}
            height={72}
            className="services-request-welcome-thinking"
            style={{ objectFit: 'contain', objectPosition: 'center', width: 72, height: 72 }}
          />
        </Layout>
        <Layout className="services-request-welcome-hi-im-codi">
          <Text size="display-sm" color="purple-gradient" wrap={false}>
            Hi, I'm Codi — your new office assistant.
          </Text>
        </Layout>
        <Layout className="services-request-welcome-lets-kick-things-off">
          <Text size="display-sm" color="purple-gradient" wrap={false}>
            Let's kick things off!
          </Text>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ServicesReqeustWelcome;
